import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
	
  },
  {
    path: '/account/login',
    name: 'accountlogin',
    component: () => import('../views/AccountLogin.vue')
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
 
    // 首页
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
	meta:{
	       title:"植物全生命周期管理系统",
	    }
	
  },
    // 个人设置
  {
    path: '/set',
    name: 'basicSet',
    component: () => import('../views/set/Index.vue'),
    children:[
      // 基础设置
      {
        path: '/set',
        component: () => import('../views/set/Basic.vue'),
        name: 'basicSet',
      },
        // 安全设置
      {
        path: '/set/security',
        component: () => import('../views/set/Security.vue'),
        name: 'security',
      },
    ],
  },
    // 实名认证
  {
    path: '/attestation/realName',
    name: 'realName',
    component: () => import('../views/attestation/RealName.vue'),
  },
    // 企业认证
  {
    path: '/attestation/company',
    name: 'company',
    component: () => import('../views/attestation/Company.vue'),
  },
    // 企业首页
  {
    path: '/enterprise',
    name: 'enterprise',
    component: () => import('../views/enterprise/Index.vue'),
  },
    // 企业设置
  {
    path: '/enterprise/set',
    name: 'enterpriseSet',
    component: () => import('../views/enterprise/Set.vue'),
  },
    // 建立园区
  {
    path: '/bulid',
    name: 'bulid',
    component: () => import('../views/build/Index.vue'),
  },
  // 园区总览
  {
    path: '/park',
    name: 'park',
    component: () => import('../views/management/Index.vue'),
    children:[
      {
        path: '/park/detail/:id',
        name: 'parkOverview',
        component: () => import('../views/management/Overview.vue'),
      },
	  
	  {
	    path: '/park/edit/:id',
	    name: 'parkEdit',
	    component: () => import('../views/management/opening/Edit.vue'),
	  },
        // 管理团队
      {
        path: '/park/team/:id',
        name: 'team',
        component: () => import('../views/management/Team.vue'),
      },
        // 农事管理（为开通）
      {
        path: '/park/notFarming/:id',
        name: 'notFarming',
        component: () => import('../views/management/NotFarming.vue'),
      },
      // 农事管理-年计划
      {
        path: '/park/farming/:id',
        name: 'notFarming',
        component: () => import('../views/management/farming/Index.vue'),
        children:[
          {
            path: '/park/farming/:id',
            name: 'annualPlan',
            component: () => import('../views/management/farming/AnnualPlan.vue'),
          },
          // 编辑年计划
          {
            path: '/park/farming/editPlan/:id/:task_id',
            name: 'editAnnualPlan',
            component: () => import('../views/management/farming/EditAnnualPlan.vue'),
          },
		  {
		    path: '/park/farming/detaill/:id/:task_id',
		    name: 'detailAnnualPlan',
		    component: () => import('../views/management/farming/detailtAnnualPlan.vue'),
		  },
		
            // 工作任务
          {
            path: '/park/farming/workTask/:id',
            name: 'workTask',
            component: () => import('../views/management/farming/workTask/Index.vue'),
			 meta: { title: '工作任务列表'}
          },
            // 预排任务 - 发布
            {
                path: '/park/farming/workTask/release/:id/:task_id',
                name: 'release',
                component: () => import('../views/management/farming/workTask/Release.vue'),
            },
			// 预排任务 - 发布
			{
			    path: '/park/farming/workTask/detail/:id/:task_id',
			    name: 'release',
			    component: () => import('../views/management/farming/workTask/Detail.vue'),
				meta: { title: '工作任务详情'}
			},
			{
			  path: '/park/farming/workTask/update/:id/:task_id',
			  name: 'update',
			  component: () => import('../views/management/farming/workTask/update.vue'),
			},
            // 安排任务 - 安排
          {
            path: '/park/farming/workTask/:id',
            name: 'arrange',
            component: () => import('../views/management/farming/workTask/Arrange.vue'),
          },
            // 进行中任务 - 填写
          {
            path: '/park/farming/workTask/:id',
            name: 'write',
            component: () => import('../views/management/farming/workTask/Write.vue'),
          },
          // 已结束任务 - 详情
          {
            path: '/park/farming/workTask/:id',
            name: 'endDetail',
            component: () => import('../views/management/farming/workTask/EndDetail.vue'),
          },
        ]
      },
      // 植株生长势
     /* {
        path: '/park/growth/:id',
        name: 'growth',
        component: () => import('../views/management/Growth.vue'),
      }, */

      //智能诊断
      {
        path: '/park/diagnosis/:id',
        name: 'diagnosis',
        component: () => import('../views/management/Diagnosis.vue'),
      },
	  //植物图谱
	  {
	     path: '/park/facial/:id',
	     name: 'facial',
	     component: () => import('../views/management/Facial.vue'),
	   },
      // 生产效益
      {
        path: '/park/benefit/:id',
        name: 'benefit',
        component: () => import('../views/management/Benefit.vue'),
      },
      // 病虫害
      {
        path: '/park/insectPest/:id',
        name: 'insectPest',
        component: () => import('../views/management/InsectPest.vue'),
      },
      // 设备设施
      {
        path: '/park/equipment/:id',
        name: 'equipment',
        component: () => import('../views/management/Equipment.vue'),
      },
      // 库存管理
      {
        path: '/park/stock/:id',
        name: 'stock',
        component: () => import('../views/management/Stock.vue'),
      },
      // 库存管理-农资明细
      {
        path: '/park/stock/detail/:id/:material_id',
        name: 'stockDetails',
        component: () => import('../views/management/StockDetails.vue'),
      },
	  // 库存管理-农资明细
	  {
	    path: '/park/sale/:id/',
	    name: 'sale',
	    component: () => import('../views/management/Sale.vue'),
	  },
    ],
  },
    // 农事管理-申请开通
  {
    path: '/applyOpen/:id',
    name: 'applyOpen',
    component: () => import('../views/management/opening/Index.vue'),
  },
    // 农事管理-资料审核中
    {
        path: '/examine/:id',
        name: 'examine',
        component: () => import('../views/management/opening/Examine.vue'),
    },
  // 园区人员配置
  {
    path: '/staffing/:id',
    name: 'staffing',
    component: () => import('../views/Staffing/Index.vue'),
  },
  // 园区信息修改
  {
    path: '/informationEdit/:id',
    name: 'informationEdit',
    component: () => import('../views/InformationEdit/Index.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
